import React, { useContext, useEffect, useMemo, useState } from 'react';
import Icon from '@ant-design/icons';
import { Button, Radio } from 'antd';
import { find, map } from 'underscore';
import { connect } from 'react-redux';
import { fetchShopTypes } from '../../modules/shop/actions/getTypes';
import { ConnectedMenuDesktop, MenuDesktop } from '../MenuDesktop';
import { useDesktop } from '../../hooks/useDesktop';
import { BurgerXS, CloseXS } from '../../shared/assets';
import { openLeftMenu, setOpenMenu } from '../../actions/openMenu';
import { LendingActions } from '../../modules/lending/components/actions';
import { Context } from '../../index';
import { useGetActiveTypesQuery } from '../../api';
import {
    flatterTree,
    LendingSectionModal,
    LendingTypesModalContent,
} from '../../modules/setting/components/lending/modal';
import { Loader } from '../loader';
import classNames from 'classnames';
import { fetchTypesOptions } from '../../modules/setting/actions/previewSideBar';
import { MobileMenuModal } from '../mobileMenuModal/MobileMenuModal';
import { Link } from 'app/shared/link/link';

const treeByIds = (ids, tree) => {
    let idsCopy = [...ids];
    function filter(item) {
        const includes = idsCopy.includes(item.id);
        if (includes) idsCopy.filter((id) => id !== item.id);
        return includes;
    }
    const copy = JSON.parse(JSON.stringify(tree)).filter(filter);
    function getNode(node) {
        if (!node.children) return;
        node.children = node.children.filter(filter);
        const children = node.children;
        for (let i = 0; i < children.length; i++) {
            getNode(children[i]);
        }
    }
    for (let i = 0; i < copy.length; i++) {
        getNode(copy[i]);
    }
    return copy;
};

const MenuItem = ({ activeType, label, children, onClick, id, level = 0 }) => {
    return (
        <>
            <Link
                to={`/categories/${id}`}
                className={'menu-item'}
                onClick={onClick}
                style={{ marginLeft: level * 25 }}
            >
                <span>{label}</span>
                <Radio
                    checked={activeType === id}
                    className="mobile-menu__radio"
                />
            </Link>
            {map(children, (type) => (
                <MenuItem
                    onClick={onClick}
                    id={type.id}
                    activeType={activeType}
                    key={type.id}
                    label={type.name}
                    level={level + 1}
                >
                    {type?.children}
                </MenuItem>
            ))}
        </>
    );
};

export const MenuMobile = ({
    dispatch,
    types,
    point,
    activeTypeGlobal,
    toggleOpenLeftMenu,
    setOpenMenu,
    saveOptions,
    user,
    open,
}) => {
    const { data, isFetching } = useGetActiveTypesQuery(
        { point: point?.id },
        { skip: !point?.id }
    );
    const {
        settings: {
            activeTypes: { snapshot, settings, setSettings },
        },
    } = useContext(Context);
    const [openTypes, setOpenTypes] = useState(false);
    const [activeType, setActiveType] = useState(activeTypeGlobal);
    useEffect(() => {
        setActiveType(activeTypeGlobal);
    }, [activeTypeGlobal]);

    function onCategory() {
        setOpenMenu(false);
    }

    const isDesktop = useDesktop();
    const list = types?.response?.lists;

    function onCancel() {
        setOpenTypes(false);
    }

    function onSave() {
        saveOptions(flatterTree(settings), () => {
            setSettings((prevState) => {
                return {
                    ...prevState,
                    snapshot: prevState.settings,
                };
            });
        });
    }

    function onEdit() {
        setOpenTypes(true);
    }

    function onSubmitTypes(types) {
        setSettings((prevState) => ({
            ...prevState,
            settings: treeByIds(types, list),
        }));
        onCancel();
    }

    function onDiscard() {
        setSettings((prevState) => ({
            ...prevState,
            settings: prevState.snapshot,
        }));
    }

    useEffect(() => {
        if (data?.data_response?.success) {
            const newState = map(data?.data_response?.types);
            setSettings((prevState) => ({
                ...prevState,
                snapshot: newState,
                settings: newState,
            }));
        }
    }, [data]);

    const typesChanged = useMemo(() => {
        return settings?.some((setting, index) => {
            let snapshotIndex = -1;
            const sectionSnapshot = find(snapshot, (item, index) => {
                const equal = item.id === setting.id;
                if (equal) {
                    snapshotIndex = index;
                }
                return equal;
            });
            return (
                settings?.length !== snapshot?.length ||
                index !== snapshotIndex ||
                sectionSnapshot?.id !== setting?.id
            );
        });
    }, [settings, snapshot]);

    const isAdmin = user?.isAdmin;

    return (
        <>
            <LendingSectionModal
                visible={openTypes}
                title={'Отображение категорий'}
                onCancel={onCancel}
            >
                <LendingTypesModalContent
                    checkStrictly={false}
                    tree={list}
                    onSubmit={onSubmitTypes}
                    initialItems={settings}
                    showAdded={false}
                />
            </LendingSectionModal>
            {isDesktop ? (
                <Button
                    type={'primary'}
                    icon={
                        <Icon
                            style={{ fontSize: 'initial' }}
                            component={open ? CloseXS : BurgerXS}
                        />
                    }
                    onClick={toggleOpenLeftMenu}
                >
                    Каталог
                </Button>
            ) : null}
            {isDesktop ? (
                open ? (
                    <ConnectedMenuDesktop
                        onEdit={onEdit}
                        onSave={onSave}
                        onCancel={onCancel}
                        onDiscard={onDiscard}
                        settings={settings}
                        typesChanged={typesChanged}
                        isFetching={isFetching}
                        isAdmin={isAdmin}
                    />
                ) : null
            ) : (
                <MobileMenuModal
                    open={open}
                    onCancel={() => {
                        setOpenMenu(false);
                    }}
                    className={classNames(
                        'menu-mobile',
                        // `${!open ? 'menu-mobile_close' : ''}`,
                        {
                            'menu-mobile_changed': typesChanged,
                        }
                    )}
                    width={'100%'}
                >
                    <div className={'menu-mobile__header'}>
                        {isAdmin ? (
                            <LendingActions
                                onEdit={onEdit}
                                onDiscard={onDiscard}
                                onSave={onSave}
                                isMobileMenu={true}
                            />
                        ) : null}
                        Категории
                    </div>
                    <div className={'menu-mobile__content'}>
                        {isFetching ? (
                            <Loader />
                        ) : (
                            map(settings, (type) => {
                                return (
                                    <MenuItem
                                        activeType={activeType}
                                        onClick={onCategory}
                                        id={type.id}
                                        key={type.id}
                                        label={type.name}
                                    >
                                        {type?.children}
                                    </MenuItem>
                                );
                            })
                        )}
                    </div>
                </MobileMenuModal>
            )}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.authState.user,
        activeTypeGlobal: state.shopState.active_type,
        types: state.shopState.types,
        point: state.shopState.order.point,
        open: state.appState.stateMenu.isOpen,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
        toggleOpenLeftMenu: () => dispatch(openLeftMenu()),
        setOpenMenu: (data) => dispatch(setOpenMenu(data)),
        saveOptions: (data, success) =>
            dispatch(fetchTypesOptions(data, success)),
    };
};

export const ConnectedMenuModal = connect(
    mapStateToProps,
    mapDispatchToProps
)(MenuMobile);
